export default "__VITE_ASSET__Dp$KQxug__"